import { FolderHomeOutlineIcon } from './FolderHomeOutlineIcon';

/**
 * author: Mitch Berninger
 * id 5CFE89BB-F160-4C01-95C8-CFDF3D2099DA
 * name folder-home-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-home-outline.svg
 * tags
 * - Files / Folders 
 * - Home Automation 
 */
export const FolderHouseOutlineIcon = FolderHomeOutlineIcon;
export default FolderHouseOutlineIcon